import React, { Suspense } from "react";
import { Card, CardHeader, CardContent, Grid, alpha, Box, Typography } from "@mui/material";
import {
  VehicleGroupsDataGrid,
  VehicleGroupsStats,
} from "../components/vehicle";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateVehicleGroupButton from "../components/vehicle/group/CreateVehicleGroupButton";

const VehicleGroups = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Suspense fallback={<StatSkeleton height={38} />}>
          <VehicleGroupsStats />
        </Suspense>
        <Grid container size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <CreateVehicleGroupButton />
        </Grid>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined">
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <VehicleGroupsDataGrid tableTitle="Available Vehicle Groups" />
            </CardContent>
          </Card>
        </Grid>
      </Grid >
    </div >
  );
};

export default VehicleGroups;
